import { parsePhoneNumber } from 'react-phone-number-input';
import type { CountryCode } from 'libphonenumber-js';

/** Mapeo país ISO → prefijo de llamada para fallback manual */
const COUNTRY_PREFIXES: Record<string, string> = {
  MX: '52',
  PE: '51',
  CO: '57',
  ES: '34',
  AR: '54',
  CL: '56',
  US: '1',
};

/**
 * Obtiene el número en formato E.164 (solo dígitos con prefijo) para wa.me.
 * Si el número ya tiene prefijo internacional (+), lo parsea.
 * Si no, usa defaultCountry para inferir el prefijo.
 */
export function getWhatsAppNumber(phone: string, defaultCountry: string): string {
  if (!phone?.trim()) return '';
  const country = (defaultCountry === 'OTHER' ? 'MX' : defaultCountry) as CountryCode;
  try {
    const parsed = parsePhoneNumber(phone, country);
    if (parsed) return parsed.number.replace('+', '');
  } catch {
    // fallback manual
  }
  const digits = phone.replace(/\D/g, '');
  if (digits.length >= 10) {
    const prefix = COUNTRY_PREFIXES[defaultCountry] ?? COUNTRY_PREFIXES['MX'];
    if (!digits.startsWith(prefix)) return prefix + digits;
    return digits;
  }
  return digits;
}
